import { v4 } from 'uuid'

export const getExecuteTemplate = <T>(
  projectMeta: ProjectMeta,
  type: string,
  personId: string,
  parameters: Partial<T>,
  expectedResponse: Partial<T> | Partial<T>[],
) => ({
  variables: {
    projectId: projectMeta.id,
    version: projectMeta.version,
    commandId: v4(),
    type,
    personId: personId,
    parameters,
  },
  optimisticResponse: {
    executeCommand: {
      version: projectMeta.version + 1,
      type,
      __typename: 'CommandResponse',
      data: [expectedResponse],
    },
  },
})
